import React, { useState, useRef, Component } from 'react';
import { MessageSquareIcon, ArrowRightIcon, XIcon, SendIcon, MailIcon } from 'lucide-react';
export function FooterUtilityBar() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [showSupportForm, setShowSupportForm] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [supportText, setSupportText] = useState('');
  // Email validation
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (value && !value.includes('@')) {
      setEmailError(`Please include an '@' in the email address.`);
    } else {
      setEmailError('');
    }
  };
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setEmailError('Please enter your email.');
      return;
    }
    if (!email.includes('@')) {
      setEmailError(`Please include an '@' in the email address.`);
      return;
    }
    alert(`Thank you for subscribing with: ${email}`);
    setEmail('');
    setEmailError('');
  };
  const handleFeedbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@joinemigo.com?subject=Feedback for Emigo&body=${encodeURIComponent(feedbackText)}`;
    setShowFeedbackForm(false);
    setFeedbackText('');
  };
  const handleSupportSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@joinemigo.com?subject=Support Request&body=${encodeURIComponent(supportText)}`;
    setShowSupportForm(false);
    setSupportText('');
  };
  return <>
      <section className="bg-[#0F172A] py-8 md:py-10" data-id="element-122">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 items-start" data-id="element-124">
            {/* Column 1: Feedback */}
            <div className="flex flex-col items-start md:pr-10 lg:pr-14" data-id="element-125">
              <h3 className="text-white text-lg font-semibold tracking-wide mb-3" data-id="element-126">
                Help Improve Emigo
              </h3>
              <p className="text-slate-400 text-sm mb-4 leading-relaxed" data-id="element-127">
                Your feedback shapes what we build next.
              </p>
              <button onClick={() => setShowFeedbackForm(true)} className="inline-flex items-center px-5 py-2.5 rounded-lg border border-white/25 text-white text-sm font-medium hover:bg-white/10 transition-all" data-id="element-128">
                <MessageSquareIcon className="w-4 h-4 mr-2" data-id="element-129" />
                Give Feedback
              </button>
            </div>

            {/* Column 2: Subscribe */}
            <div className="flex flex-col items-start md:px-10 lg:px-14 md:border-x md:border-white/[0.08]" data-id="element-130">
              <h3 className="text-white text-lg font-semibold tracking-wide mb-3" data-id="element-131">
                Get Updates
              </h3>
              <form onSubmit={handleSubscribe} className="w-full" data-id="element-132">
                <div className="flex gap-2" data-id="element-133">
                  <div className="relative flex-1" data-id="element-134">
                    <input type="email" value={email} onChange={handleEmailChange} className="w-full px-4 py-2.5 rounded-lg bg-white/10 border border-white/15 text-white placeholder-slate-400 text-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-transparent" placeholder="Email address" autoComplete="email" data-id="element-135" />
                    {emailError && <div className="absolute -bottom-7 left-0 text-xs text-red-400" data-id="element-136">
                        {emailError}
                      </div>}
                  </div>
                  <button type="submit" className="px-5 py-2.5 bg-[#E87B5C] text-white text-sm font-semibold rounded-lg hover:bg-[#D16A4A] transition-all flex items-center flex-shrink-0" data-id="element-137">
                    Subscribe
                    <ArrowRightIcon className="ml-1.5 h-4 w-4" data-id="element-138" />
                  </button>
                </div>
              </form>
            </div>

            {/* Column 3: Support */}
            <div className="flex flex-col items-start md:pl-10 lg:pl-14" data-id="element-139">
              <h3 className="text-white text-lg font-semibold tracking-wide mb-3" data-id="element-140">
                Need Help?
              </h3>
              <p className="text-slate-400 text-sm mb-4 leading-relaxed" data-id="element-141">
                We're here if you have questions.
              </p>
              <button onClick={() => setShowSupportForm(true)} className="inline-flex items-center text-slate-300 text-sm font-medium hover:text-white transition-colors group" data-id="element-142">
                <MailIcon className="w-4 h-4 mr-2" data-id="element-143" />
                Contact Support
                <ArrowRightIcon className="ml-1.5 h-3.5 w-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-144" />
              </button>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-white/10" data-id="element-145">
                <a href="/terms-of-service" className="text-slate-400 text-xs hover:text-white transition-colors" data-id="element-146">
                  Terms of Service
                </a>
                <span className="text-slate-600 text-xs" data-id="element-147">·</span>
                <a href="/privacy-policy" className="text-slate-400 text-xs hover:text-white transition-colors" data-id="element-148">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feedback Modal */}
      {showFeedbackForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black/50" data-id="element-149">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-id="element-150">
            <div className="flex justify-between items-center mb-6" data-id="element-151">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-152">
                Share Your Feedback
              </h2>
              <button onClick={() => {
            setShowFeedbackForm(false);
            setFeedbackText('');
          }} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-153">
                <XIcon className="w-5 h-5" data-id="element-154" />
              </button>
            </div>
            <form onSubmit={handleFeedbackSubmit} className="space-y-4" data-id="element-155">
              <textarea value={feedbackText} onChange={e => setFeedbackText(e.target.value)} rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" placeholder="How can we improve Emigo to better serve your needs?" required data-id="element-156" />
              <div className="flex justify-end space-x-3 pt-2" data-id="element-157">
                <button type="button" onClick={() => {
              setShowFeedbackForm(false);
              setFeedbackText('');
            }} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-158">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-[#E87B5C] text-white rounded-md hover:bg-[#D16A4A] transition-colors flex items-center" data-id="element-159">
                  Submit to info@joinemigo.com
                  <SendIcon className="ml-2 h-4 w-4" data-id="element-160" />
                </button>
              </div>
            </form>
          </div>
        </div>}

      {/* Support Modal */}
      {showSupportForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black/50" data-id="element-161">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-id="element-162">
            <div className="flex justify-between items-center mb-6" data-id="element-163">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-164">
                Contact Support
              </h2>
              <button onClick={() => {
            setShowSupportForm(false);
            setSupportText('');
          }} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-165">
                <XIcon className="w-5 h-5" data-id="element-166" />
              </button>
            </div>
            <form onSubmit={handleSupportSubmit} className="space-y-4" data-id="element-167">
              <textarea value={supportText} onChange={e => setSupportText(e.target.value)} rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" placeholder="How can we help you?" required data-id="element-168" />
              <div className="flex justify-end space-x-3 pt-2" data-id="element-169">
                <button type="button" onClick={() => {
              setShowSupportForm(false);
              setSupportText('');
            }} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-170">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-[#E87B5C] text-white rounded-md hover:bg-[#D16A4A] transition-colors flex items-center" data-id="element-171">
                  Submit to info@joinemigo.com
                  <SendIcon className="ml-2 h-4 w-4" data-id="element-172" />
                </button>
              </div>
            </form>
          </div>
        </div>}
    </>;
}
export default FooterUtilityBar;